var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dt-row-user" }, [
    _c(
      "div",
      { staticClass: "dt-row-detail", class: { active: _vm.index % 2 == 1 } },
      [
        _c(
          "div",
          {
            staticClass: "body-col",
            style: {
              width: _vm.columnWidth.firstName.size
                ? _vm.columnWidth.firstName.size + "px"
                : "12%"
            }
          },
          [_vm._v("\n      " + _vm._s(_vm.userInfo.firstName) + "\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "body-col",
            style: {
              width: _vm.columnWidth.lastName.size
                ? _vm.columnWidth.lastName.size + "px"
                : "12%"
            }
          },
          [_vm._v("\n      " + _vm._s(_vm.userInfo.lastName) + "\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "body-col",
            style: {
              width: _vm.columnWidth.email.size
                ? _vm.columnWidth.email.size + "px"
                : "22%"
            }
          },
          [_vm._v("\n      " + _vm._s(_vm.userInfo.email) + "\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "body-col",
            style: {
              width: _vm.columnWidth.clientAccount.size
                ? _vm.columnWidth.phone.size + "px"
                : "12%"
            }
          },
          [_vm._v("\n      " + _vm._s(_vm.userInfo.phoneNumber) + "\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "body-col",
            style: {
              width: _vm.columnWidth.clientAccount.size
                ? _vm.columnWidth.clientAccount.size + "px"
                : "10%"
            }
          },
          [_vm._v("\n      " + _vm._s(_vm.clientName) + "\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "body-col",
            style: {
              width: _vm.columnWidth.role.size
                ? _vm.columnWidth.role.size + "px"
                : "10%"
            }
          },
          [_vm._v("\n      " + _vm._s(_vm.showRoleText) + "\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "body-col",
            style: {
              width: _vm.columnWidth.status.size
                ? _vm.columnWidth.status.size + "px"
                : "14%"
            }
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.userInfo.status || "Account is not on Cognito") +
                "\n    "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "body-col col-action",
            style: {
              width: _vm.columnWidth.action.size
                ? _vm.columnWidth.action.size + "px"
                : "8%"
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "wrapper",
                on: {
                  click: function($event) {
                    _vm.editUserInfo()
                  }
                }
              },
              [
                _c(
                  "span",
                  [
                    _c("Icon", {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover.bottom",
                          modifiers: { hover: true, bottom: true }
                        }
                      ],
                      staticClass: "icon",
                      attrs: { title: _vm.instructions.edit, name: "pencil" }
                    })
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "wrapper",
                on: {
                  click: function($event) {
                    _vm.deleteUser()
                  }
                }
              },
              [
                _c(
                  "span",
                  [
                    _c("Icon", {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover.bottom",
                          modifiers: { hover: true, bottom: true }
                        }
                      ],
                      staticClass: "icon",
                      attrs: {
                        title: _vm.instructions.delete,
                        name: _vm.iconNames.trashO
                      }
                    })
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "wrapper",
                on: {
                  click: function($event) {
                    _vm.forceUserResetPassword()
                  }
                }
              },
              [
                _c("span", [
                  _c("img", {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.hover.bottom",
                        modifiers: { hover: true, bottom: true }
                      }
                    ],
                    staticClass: "icon",
                    attrs: {
                      src: require("../../../static/img/user-lock.svg"),
                      title: _vm.instructions.forceResetPassword
                    }
                  })
                ])
              ]
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-20e3ce0e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20e3ce0e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/UserRow.vue
// module id = 2039
// module chunks = 1